import { render, staticRenderFns } from "./ReplyPendencyModal.vue?vue&type=template&id=ef0bc742"
import script from "./ReplyPendencyModal.vue?vue&type=script&lang=js"
export * from "./ReplyPendencyModal.vue?vue&type=script&lang=js"
import style0 from "./ReplyPendencyModal.vue?vue&type=style&index=0&id=ef0bc742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports